import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/uzlet',
      component: Home,
      props: {
        p: '0',
      },
    },
    {
      path: '/media',
      component: Home,
      props: {
        p: '2',
      },
    },
    {
      path: '/kozelet',
      component: Home,
      props: {
        p: '3',
      },
    },
    {
      path: '/kultura',
      component: Home,
      props: {
        p: '4',
      },
    },
    {
      path: '/forbes-arcok',
      component: Home,
      props: {
        p: '5',
      },
    },
  ],
});
